import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserManagementService } from "src/app/user-management/user-management.service";
import * as CryptoJS from "crypto-js";
import { SessionService } from "src/app/session.service";
import { environment } from "src/environments/environment";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { ExecutiveHighlightService } from "../shared/ExecutiveHighlightService.service";

@Component({
    selector: "app-user-management-sites",
    templateUrl: "./user-management-sites.component.html",
    styleUrls: ["./user-management-sites.component.css"],
    standalone: false
})

export class UserManagementSitesComponent implements OnInit {
  private storage = environment.storage;
  users: any[] = [];
  plant: any[] = [];
  teamMembers = [];
  executiveMembers = [];
  loginForm: any;
  errorMessage: string = "";
  executive: any[] = [];
  showLeavePopup = false;
  private pendingPopStateEvent: PopStateEvent | null = null;
  popStateListener: any;
  popupOpen = false;
  showCheckboxes = false;
  showExecutiveConfig = false;
  executiveConfigChoice: 'yes' | 'no' = 'no';
  siteSearch: string = '';
  availableSites: any[] = [];
  selectedSitesForConfig: any[] = [];
  executiveConfigSaved = false;
  summaryData: any[] = [];
  showSummaryPopup = false;
  apiProcessingDone = false;
  apiProcessingInterval: any;
  executiveApiProcessingDone = false;
  executiveCountdown: number = 10;
  executiveCountdownInterval: any;

  constructor(
    private userService: UserManagementService,
    private router: Router,
    private sessionService: SessionService,
    private executiveHighlightService: ExecutiveHighlightService
  ) {}

  ngOnInit(): void {
     this.fetchAvailableSites();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url === "/user-management-sites") {
          this.fetchUsers();
        }
      });
    this.fetchUsers();
    this.fetchUsersE();
    sessionStorage.setItem("visitedUserManagementSites", "true");
    
    // Store the original admin role (16) when first visiting this page
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    if (Number(currentUser.role) === 16) {
      sessionStorage.setItem("originalAdminRole", "16");
    }

    if (
      window.history.state === null ||
      window.history.state !== "user-management-sites"
    ) {
      history.replaceState("user-management-sites", "", this.router.url);
      history.pushState(null, "", this.router.url);
    }

    this.popStateListener = (event: PopStateEvent) => {
      const targetPath = window.location.pathname;
      if (
        targetPath === "/user-management-sites" &&
        sessionStorage.getItem("visitedUserManagementSites") === "true"
      ) {
        this.pendingPopStateEvent = event;
        this.showLeavePopup = true;
        history.pushState(null, "", this.router.url);
      }
    };
    window.addEventListener("popstate", this.popStateListener);
  }
  ngOnDestroy(): void {
    window.removeEventListener("popstate", this.popStateListener);
  }
  onStay() {
    this.showLeavePopup = false;
    this.pendingPopStateEvent = null;
  }

  onLeave() {
    this.showLeavePopup = false;
    this.pendingPopStateEvent = null;
    this.logout();
  }

  logout() {
    this.userService.logout();
    sessionStorage.removeItem("visitedUserManagementSites");
    this.router.navigate(["/login"]);
  }

  fetchUsers() {
    const adminUser = JSON.parse(localStorage.getItem('user') || '{}');
    const admin_user_id = Number(adminUser.id);
    sessionStorage.setItem('admin_id', admin_user_id.toString());
    this.userService.getPlants(admin_user_id).subscribe((response) => {
      if (response.status === 1) {
        this.plant = response.plants;
        this.teamMembers = this.plant.map((plant, index) => {
          const mappedMember = {
            name: `${plant.site_name}`,
            site_id: plant.site_id,
            user_id: plant.user_id,
            admin_id: plant.admin_user_id,
          };
          return mappedMember;
        });
      }
    });
  }

  fetchUsersE() {
    const adminUser = JSON.parse(localStorage.getItem('user') || '{}');
    const admin_user_id = Number(adminUser.id);
    this.userService.getExecutive(admin_user_id).subscribe((response) => {
      if (response.status === 1) {
        this.executive = response.executives;
        this.executiveMembers = this.executive.map((exec, index) => {
          const mappedExecutive = {
            name: `${exec.site_name}`,
            site_id: exec.site_id,
            user_id: exec.executive_id,
            admin_id: exec.admin_user_id,
          };
          return mappedExecutive;
        });
      }
    });
  }

  // Helper method to build login payload with conditional role_type
  buildLoginPayload(username: string, hashedPassword: string): any {
    const loginPayload: any = {
      email: username,
      password: hashedPassword,
      purpose: "login",
    };

    // Add role_type = 16 if original admin had role 16 and visited user management sites
    const originalAdminRole = sessionStorage.getItem('originalAdminRole');
    const visitedUserManagementSites = sessionStorage.getItem('visitedUserManagementSites') === 'true';
    
    // Debug logging
    console.log('buildLoginPayload - originalAdminRole:', originalAdminRole);
    console.log('buildLoginPayload - visitedUserManagementSites:', visitedUserManagementSites);
    
    // Check if original admin had role 16 and visited user management sites
    if (originalAdminRole === '16' && visitedUserManagementSites) {
      loginPayload.role_type = 16;
      console.log('buildLoginPayload - Added role_type: 16 to payload');
    }

    console.log('buildLoginPayload - Final payload:', loginPayload);
    return loginPayload;
  }

  switchUser(mappedMember: { site_id: number; user_id: number; name?: string }) {
    localStorage.setItem("dashboardSwitcherMode", "plant");
    localStorage.setItem("currentSiteId", mappedMember.site_id.toString());
    localStorage.setItem("currentSiteName", mappedMember.name || "");
    localStorage.setItem("currentDashboardType", "plant");
    const adminId = Number(localStorage.getItem("admin_id"));
    const { site_id, user_id } = mappedMember;

    this.userService.getUserCredentials(user_id).subscribe(
      (response: any) => {
        if (response.status === 1 && response.username && response.password) {
          const { username, password } = response;
          const SECRET_KEY = "purbi123";
          const hashedPassword = CryptoJS.AES.encrypt(
            password,
            SECRET_KEY
          ).toString();

          // Build login payload with conditional role_type
          const loginPayload = this.buildLoginPayload(username, hashedPassword);

          this.userService
            .login(loginPayload)
            .then((loginResponse: any) => {
              if (loginResponse.status === 1) {
                if (
                  loginResponse &&
                  loginResponse.status === 1 &&
                  loginResponse.user
                ) {
                  const siteInfo = JSON.parse(
                    JSON.stringify(loginResponse.user.allsites)
                  );
                  delete loginResponse.user.allsites;
                  this.userService.addUserDetail(loginResponse.user);
                  this.userService.addSiteDetails(siteInfo);
                  this.sessionService.resetSessionTimeout();

                  if (loginResponse.user.role === 16) {
                    this.router
                      .navigate(["/user-management-sites"])
                      .then(() => {});
                  } else if (loginResponse.user.role === 13) {
                    this.router.navigate(["reportlibrary/editreport/process"]);
                  } else {
                    this.router.navigate(["/"]).then(() => {
                      window.location.reload();
                    });
                  }
                } else {
                  this.loginForm.get("password").setValue("");
                  this.errorMessage =
                    loginResponse.msg || "Invalid login credentials.";
                }
              }
            })
            .catch((error) => {});
        }
      },
      (error) => {}
    );
  }

  switchExecutive(
    mappedExecutive: { site_id: number; user_id: number; name?: string },
    executive: any,
    index: number
  ) {
    this.executiveHighlightService.setHighlight(index, 12);
    localStorage.setItem("dashboardSwitcherMode", "executive");
    localStorage.setItem("dashboardSwitcherExecutiveIndex", index.toString());
    localStorage.setItem("currentSiteId", mappedExecutive.site_id.toString());
    localStorage.setItem("currentSiteName", mappedExecutive.name || "");
    localStorage.setItem("currentDashboardType", "executive");
    const adminId = Number(localStorage.getItem("admin_id"));
    const { site_id, user_id } = mappedExecutive;

    this.userService.getUserCredentials(user_id).subscribe(
      (response: any) => {
        if (response.status === 1 && response.username && response.password) {
          const { username, password } = response;
          const SECRET_KEY = "purbi123";
          const hashedPassword = CryptoJS.AES.encrypt(
            password,
            SECRET_KEY
          ).toString();

          // Build login payload with conditional role_type
          const loginPayload = this.buildLoginPayload(username, hashedPassword);

          this.userService
            .login(loginPayload)
            .then((loginResponse: any) => {
              if (loginResponse.status === 1) {
                if (
                  loginResponse &&
                  loginResponse.status === 1 &&
                  loginResponse.user
                ) {
                  const siteInfo = JSON.parse(
                    JSON.stringify(loginResponse.user.allsites)
                  );
                  delete loginResponse.user.allsites;
                  this.userService.addUserDetail(loginResponse.user);
                  this.userService.addSiteDetails(siteInfo);
                  this.sessionService.resetSessionTimeout();

                  if (loginResponse.user.role === 16) {
                    this.router
                      .navigate(["/user-management-sites"])
                      .then(() => {});
                  } else if (loginResponse.user.role === 13) {
                    this.router.navigate(["reportlibrary/editreport/process"]);
                  } else {
                    this.router.navigate(["/"]).then(() => {
                      window.location.reload();
                    });
                  }
                } else {
                  this.loginForm.get("password").setValue("");
                  this.errorMessage =
                    loginResponse.msg || "Invalid login credentials.";
                }
              }
            })
            .catch((error) => {});
        }
      },
      (error) => {}
    );
  }

  openPopup() {
    this.popupOpen = true;
    this.showCheckboxes = false;
  }

  closePopup() {
    if (!this.executiveConfigSaved) {
      this.showCheckboxes = false;
      this.showExecutiveConfig = false;
      this.executiveConfigChoice = 'no';
      this.siteSearch = '';
      this.selectedSitesForConfig = [];
      this.availableSites.forEach(site => {
        site.execSelected = false;
        site.executiveUsername = '';
        site.executivePassword = '';
      });
      this.popupOpen = false;
    } else {
      this.popupOpen = false;
    }
  }

  showSummary() {
    this.popupOpen = true;
    this.showCheckboxes = false;
    this.showExecutiveConfig = false;
  }

  onSiteCheckboxChange(site: any) {
    if (this.executiveConfigSaved) {
      this.executiveConfigSaved = false;
      this.showExecutiveConfig = false;
    }
    this.saveSelectedSiteIds();
  }

  submitSelectedSites() {
    this.selectedSitesForConfig = this.availableSites.filter(site => site.selected);
    this.showExecutiveConfig = true;
  }
  
  fetchAvailableSites() {
    this.userService.getAvailableSites().subscribe(
      (sites) => {
      const selectedIds: number[] = JSON.parse(localStorage.getItem('selectedSiteIds') || '[]');
      this.availableSites = sites.map(site => ({
        ...site,
        selected: selectedIds.includes(site.site_id)
      }));
    },
      (error) => {}
    );
  }

  get filteredSites() {
    if (!this.siteSearch) return this.availableSites;
    return this.availableSites.filter(site =>
      (site.site_name || '').toLowerCase().includes(this.siteSearch.toLowerCase())
    );
  }

  onAddSitesClick() {
    this.fetchAvailableSites();
    this.showCheckboxes = true;
  }

    startApiProcessingStatusPolling() {
      this.apiProcessingDone = false;

      this.userService.getSiteSetupStatus(this.summaryData).subscribe(
        (res: any) => {
          if (res.sites && Array.isArray(res.sites)) {
            this.summaryData = this.summaryData.map(site => {
              const backendSite = res.sites.find((s: any) => s.site_id === site.site_id);
              const merged = backendSite ? { ...site, ...backendSite } : site;
              return merged;
            });

            const executiveCredentials = this.summaryData
              .filter(site => site.executiveUsername && site.executivePassword)
              .map(site => ({
                site_id: site.site_id,
                executiveUsername: site.executiveUsername,
                executivePassword: site.executivePassword
              }));

            if (executiveCredentials.length > 0) {
              this.executiveApiProcessingDone = false;
              this.userService.setupExecutiveForPlant(executiveCredentials).subscribe(
                (response: any) => {
                  this.executiveApiProcessingDone = true;
                  this.executiveCountdown = 15;
                  this.executiveCountdownInterval = setInterval(() => {
                  this.executiveCountdown--;
                  if (this.executiveCountdown <= 0) {
                    clearInterval(this.executiveCountdownInterval);
                        this.showSummaryPopup = false;
                  }
                  }, 1000);
                  let finalExecutiveSiteArray: any[] = [];

                  if (response.results && Array.isArray(response.results)) {
                    const adminUser = JSON.parse(localStorage.getItem('user') || '{}');
                    const admin_user_id = Number(adminUser.id);

                    finalExecutiveSiteArray = this.summaryData.map(site => {
                      const execSite = response.results.find((s: any) => s.site_id === site.site_id);
                      let merged = execSite ? { ...site, ...execSite } : site;
                      const { executiveUsername, executivePassword, ...rest } = merged;
                      return { ...rest, admin_user_id };
                    });

                    this.userService.finalPlantCustomization(finalExecutiveSiteArray).subscribe(
                      (resp: any) => {},
                      (error) => {}
                    );
                  }
                },
                (error) => {
                  this.executiveApiProcessingDone = true;
                }
              );
            } else {
              this.executiveApiProcessingDone = true;
            }
          }

          if (res.done) {
            this.apiProcessingDone = true;
          }
        },
        (error) => {}
      );
    }

  saveExecutiveConfig() {
    this.executiveConfigSaved = true;

    this.summaryData = this.selectedSitesForConfig.map(site => {
      const base = {
        site_id: site.site_id,
        site_name: site.site_name
      };
      if (this.executiveConfigChoice === 'yes' && site.execSelected) {
        return {
          ...base,
          executiveUsername: site.executiveUsername,
          executivePassword: site.executivePassword
        };
      }
      return base;
    });

    this.popupOpen = false;
    this.apiProcessingDone = false;
    setTimeout(() => {
      this.showSummaryPopup = true;
      this.startApiProcessingStatusPolling();
    }, 300);
  }

  saveSelectedSiteIds() {
    const selectedIds = this.availableSites.filter(site => site.selected).map(site => site.site_id);
    localStorage.setItem('selectedSiteIds', JSON.stringify(selectedIds));
  }
}
